import {
  SET_VIEWS,
  SET_CURRENT_VIEW,
  SET_VIEW_SLOTS,
  SAVE_ORIGINAL_CAMERAS,
  RESTORE_ORIGINAL_CAMERAS,
  SET_VIEW_DIRTY,
  CLEAR_VIEW_DIRTY,
  SET_VIEW_PRISTINE,
  LOGOUT_USER,
  EXPIRE_SESSION,
  SET_ALL_CAMERAS
} from '../actions/types';

const INITIAL_STATE = {
  views: [],           // Array of view names: [{ sName: "Front Cameras", fGlobal: false, fDefault: false }, ...]
  currentView: '',     // Currently selected view name
  viewSlots: {},       // Map of view name to slots: { "Front Cameras": [{ ixSlot: 0, bSerial: 256, bCamera: 1, ... }, ...] }
  originalCameras: null, // Store original camera array before views are applied
  isViewActive: false,   // Track if a view is currently active
  isDirty: false,       // Track if current view has unsaved changes (coarse: set on any edit)
  pristineCameras: null // The camera layout as the current view was last SELECTED/SAVED, so the
                        // "unsaved" dot can compare against it and CLEAR when a change is reverted.
};

export default function viewReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGOUT_USER:
    case EXPIRE_SESSION:
      return INITIAL_STATE;

    case SET_VIEWS:
      // When views are set to empty (during a JUMP to another system), clear viewSlots AND reset the dirty
      // baseline: the old view's pristine snapshot no longer corresponds to the new system's cameras, so
      // without this the "unsaved" dot + Save banner false-positive across a jump (David 2026-08-05 — the
      // comparison is meaningless once we've switched systems). A genuine rearrange never empties the view
      // list, so its pristine is preserved.
      const clearSlots = Array.isArray(action.payload) && action.payload.length === 0;
      return {
        ...state,
        views: action.payload,
        viewSlots: clearSlots ? {} : state.viewSlots,
        pristineCameras: clearSlots ? null : state.pristineCameras,
        isDirty: clearSlots ? false : state.isDirty
      };

    case SET_CURRENT_VIEW:
      return {
        ...state,
        currentView: action.payload
      };

    case SET_VIEW_SLOTS:
      return {
        ...state,
        viewSlots: {
          ...state.viewSlots,
          [action.viewName]: action.payload
        }
      };

    case SAVE_ORIGINAL_CAMERAS:
      return {
        ...state,
        originalCameras: action.payload,
        isViewActive: true
      };

    case RESTORE_ORIGINAL_CAMERAS:
      return {
        ...state,
        currentView: '',
        isViewActive: false,
        isDirty: false,
        pristineCameras: null
      };

    case SET_VIEW_PRISTINE:
      // Snapshot the freshly-selected/saved layout as the clean baseline for the dirty dot.
      return {
        ...state,
        pristineCameras: action.payload
      };

    case SET_VIEW_DIRTY:
      return {
        ...state,
        isDirty: action.payload
      };

    case CLEAR_VIEW_DIRTY:
      return {
        ...state,
        isDirty: false
      };

    case SET_ALL_CAMERAS:
      // When cameras are updated via slot assignment, don't clear dirty flag
      // (Only clear when explicitly loading a new view or saving)
      return state;

    default:
      return state;
  }
};
